// Fallback-Titel für die mobile Top-Leiste (MobileShellTop, <640): Routen,
// die keinen eigenen Titel via useMobilePageTitle registrieren, bekommen den
// Label ihres Sidebar-Nav-Eintrags (lib/nav.ts) — Detailseiten über den
// längsten Segment-Präfix (z.B. /documents/abc → „Dateien"). Ohne Treffer
// null → die Leiste zeigt eine leere Mitte (Minimal-Bar bleibt funktional).
//
// Pure Funktion, damit sie ohne DOM testbar ist (mobile-title.test.ts).

import { NAV_GROUPS } from './nav'

const NAV_TITLES: ReadonlyArray<readonly [path: string, label: string]> = NAV_GROUPS.flatMap((g) =>
  g.items.map((it) => [it.to, it.label] as const),
)

export function resolveMobileTitle(pathname: string): string | null {
  if (!pathname) return null
  // Trailing slash normalisieren ("/tickets/" === "/tickets"), Root bleibt "/".
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname

  let best: string | null = null
  let bestLen = 0
  for (const [to, label] of NAV_TITLES) {
    // "/" ist Präfix von allem — nur exakt matchen, sonst hieße jede
    // unbekannte Route „Dashboard".
    if (to === '/') {
      if (path === '/') return label
      continue
    }
    // Exakt oder Kind-Route an Segment-Grenze; längster Treffer gewinnt
    // (z.B. /settings/teams vor einem kürzeren /settings-Eintrag).
    if ((path === to || path.startsWith(`${to}/`)) && to.length > bestLen) {
      best = label
      bestLen = to.length
    }
  }
  return best
}
